import { Popover } from '@eatclub-apps/ec-component-library';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Button } from '../../../../components/Button';
import { Spacer } from '../../../../components/Spacer';
import { Typography } from '../../../../components/Typography';
import { eventPropTypes } from '../../../../data/models/Event';
import { experiencesPropTypes } from '../../../../data/models/Experience';
import { restaurantPropTypes } from '../../../../data/models/Restaurant';
import { trackEvent } from '../../../../utils/analytics';
import { useIsMobile } from '../../../../utils/hooks';
import { Calendar } from './Calendar';
import { DateScroll } from './DateScroll';

const SelectADate = ({ restaurant, experiences, event }) => {
  const [viewAllAnchorEl, setViewAllAnchorEl] = useState(null);
  const isMobile = useIsMobile();

  const location = useLocation();
  const pathname = location.pathname.slice(1);
  const isEventMode = pathname?.includes('/e/');

  const onClose = () => setViewAllAnchorEl(null);

  const eventDates = event?.data?.eventDates;

  // In event mode, show 7-day view by default
  if (isEventMode) {
    if (eventDates?.length <= 1) {
      return null;
    }
    return (
      <Spacer direction='vertical' gap='m'>
        <Spacer centered style={{ justifyContent: 'space-between', minHeight: '32.5px' }} wrap>
          <Typography variant='h4'>Search availability</Typography>
        </Spacer>
        <DateScroll />
      </Spacer>
    );
  }

  if (restaurant.data.dateSelectorType === '7_days') {
    return (
      <Spacer direction='vertical' gap='m'>
        <Spacer centered style={{ justifyContent: 'space-between', minHeight: '32.5px' }} wrap>
          <Typography variant='h4'>Search availability</Typography>
          <Button
            variant='outlined'
            size='small'
            onClick={(e) => {
              trackEvent('Date', 'Viewed All Dates');
              setViewAllAnchorEl(e.currentTarget);
            }}
          >
            <Typography variant='small'>Calendar</Typography>
          </Button>
        </Spacer>

        <DateScroll />

        <Popover
          isOpen={!!viewAllAnchorEl}
          onClose={onClose}
          anchorEl={viewAllAnchorEl}
          innerStyle={{
            borderRadius: '6px',
            padding: 0,
            position: 'relative',
            marginTop: '10px',
            maxWidth: !isMobile && '540px',
            width: '100%',
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Calendar onChange={onClose} />
        </Popover>
      </Spacer>
    );
  }

  // TODO figure out consistent logic for this
  const showExperiencesView =
    restaurant.data.dateSelectorType === 'experiences' || experiences.data.length > 1;

  return (
    <Calendar
      defaultView={!showExperiencesView}
      alwaysOpen={restaurant.data.dateSelectorType === 'calendar_always' || showExperiencesView}
    />
  );
};

SelectADate.propTypes = {
  restaurant: restaurantPropTypes.isRequired,
  experiences: experiencesPropTypes.isRequired,
  event: eventPropTypes.isRequired,
};

const mapStateToProps = (state) => ({
  restaurant: state.restaurant,
  experiences: state.experiences,
  event: state.event,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SelectADate);
